import ResourcesModule from '../../resources/resources';

export class EditSegmentModalController {
  /* @ngInject */
  constructor(segment, close, enablePreviews) {
    this.segment = segment;
    this.close = close;
    this.enablePreviews = typeof enablePreviews === 'undefined' ? true : enablePreviews;
  }
}

export default angular.module('app.components.segments.editModal', [
  ResourcesModule.name
])
  .controller('EditSegmentModalController', EditSegmentModalController);



/** WEBPACK FOOTER **
 ** ./src/components/segments/segmentsEditModal.js
 **/